import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Result from './ResultformatGTU';

export default function ReassResult() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const modalRef = useRef();
  const { examId, examName } = location.state || {};

  const [records, setRecords] = useState([]);
  const [clientData, setClientData] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [result, setResult] = useState([]);
  const childRef = useRef();
  const [count, setCount] = useState(0);

  const handleButtonClick = () => {
    // Call the child function when parent button is clicked
    childRef.current.callChildFunction();
  };

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchData(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage]);

  const fetchData = async (page, limit) => {
    const token = localStorage.getItem('token');
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/api/result/${examId}`, {
        params: {
          page,
          limit,
          resultType: 'REASSESSMENT',
        },
        headers: {
          Authorization: token,
        },
      });
      const { resultData, pagination, clientData } = response.data;
      setClientData(clientData);
      setRecords(resultData);

      setTotalRows(pagination.totalResults); // Make sure this matches the total number of records
      setLoading(false);
      setCount(pagination.totalResults);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, rowsPerPage); // Fetch new page data
  };

  const handleRowsPerPageChange = async (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
    await fetchData(page, newPerPage); // Fetch data with new rows per page
  };

  // Helper function to determine pass/fail status
  const getPassFailStatus = (subjects) => {
    if (!subjects || subjects.length === 0) return 'Fail';
    const allSubjectsPass = subjects.every(
      (subject) =>
        subject.internalStatus === 'Pass' && subject.externalStatus === 'Pass'
    );
    return allSubjectsPass ? 'Pass' : 'Fail';
  };

  // Base columns for student details
  const baseColumns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      center: 'true',
      width: '50px',
    },
    {
      name: 'Roll Number',
      selector: (row) => row.studentRollNumber,
      sortable: true,
      width: '118px',
      center: 'true',
    },
    {
      name: 'Name',
      selector: (row) => row.studentName,
      sortable: true,
    },
  ];

  // Dynamically create columns for subjects
  const dynamicSubjectColumns =
    records.length > 0
      ? records[0].subjects.map((subject, index) => {
          return {
            name: `${subject.subjectName} `,
            selector: (row) => {
              const subjectData = row.subjects.find(
                (sub) => sub.subjectCode === subject.subjectCode
              );
              return subjectData ? (
                <>
                  <strong className="text-success">
                    {subjectData.externalSubjectMarks} /{' '}
                    {subjectData.externalTotalMarks}
                  </strong>{' '}
                  || {subjectData.oldexternalSubjectMarks}/
                  {subjectData.externalTotalMarks}
                </>
              ) : (
                ''
              );
            },
            center: 'true',
          };
        })
      : [];

  // "Pass/Fail" column with Bootstrap styling
  const passFailColumn = {
    name: 'Pass/Fail',
    selector: (row) => {
      const status = getPassFailStatus(row.subjects);
      const textClass =
        status === 'Pass'
          ? 'badge rounded-pill bg-success px-3 '
          : 'badge rounded-pill bg-danger px-3';
      return (
        <span className={textClass}>
          <strong>{status}</strong>
        </span>
      );
    },
    center: 'true',
  };

  // Combine columns in the desired order
  const columns = [...baseColumns, ...dynamicSubjectColumns, passFailColumn];

  const HeyButton = () => {
    setResult(selectedRows);

    if (modalRef.current) {
      const modal = new window.bootstrap.Modal(modalRef.current);
      modal.show();
    }
  };

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  return (
    <AdminLayout ac8="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate(-2)}
              >
                Exams
              </li>
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate(-1)}
              >
                Result List
              </li>
              <li className="breadcrumb-item active">
                Reassessment Result ({count})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <div className="row">
          <div className="container ">
            <div className="datatable-top">
              <div className="datatable-search d-flex">
                <input
                  className="form-control"
                  type="search"
                  placeholder="Search"
                  title="Search within table"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <span style={{ marginLeft: '200px' }}>
                <strong>Exam Name:- {examName}</strong>
              </span>
            </div>
            <div className="table-responsive">
              <DataTable
                columns={columns}
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                data={records.filter((record) => {
                  const nameMatches = record.name
                    ? record.name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    : false;

                  const studentRollNumberMatches = record.studentRollNumber
                    ? record.studentRollNumber
                        .toString()
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    : false;

                  const studentNameMatches = record.studentName
                    ? record.studentName
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    : false;

                  return (
                    nameMatches ||
                    studentRollNumberMatches ||
                    studentNameMatches
                  );
                })}
                progressPending={loading}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationRowsPerPageOptions={
                  totalRows > 40
                    ? [10, 15, 20, 40, totalRows]
                    : [10, 15, 20, 40]
                }
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleRowsPerPageChange}
                paginationPerPage={rowsPerPage}
                paginationDefaultPage={currentPage}
                className="custom-table"
              />
              <ToastContainer position="top-center" style={{ width: 'auto' }} />
              <div className="col-sm-12 pt-3 text-end">
                <button
                  type="button"
                  className="btn btn-primary px-3"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-bar-left"></i> Back
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-4 mx-2"
                  onClick={HeyButton}
                >
                  Result
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Modal for Extra Barcode */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <h5
                className="modal-title text-white p-1 rounded"
                id="exampleModalLabel"
              >
                Students Result
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <Result
                selectedRows={result}
                clientData={clientData}
                examName={examName}
                ref={childRef}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary mx-1"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary mx-1"
                onClick={handleButtonClick}
              >
                {' '}
                Print Result
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
